import React from "react";

const Contact = () => {
    return(
        <section id="contact" className="py-20 bg-color2">
            <div className="container mx-auto px-6 text-center">
                <h2 className="text-4xl font-bold mb-0 text-white">Contact Me</h2>
                <p className="text-md text-white">
                    Feel free to leave me a message
                </p>
                <p className="text-xl mb-4 font-semibold text-white">
                    rafamuhammadrafa548@gmail.com
                </p>
                <a href="mailto:rafamuhammadrafa548@gmail.com" className="bg-color3 text-white font-semibold py-2 px-3 rounded-lg hover:shadow-glow transition duration-300">
                    Send Mail
                </a>
            </div>
        </section>
    )
}

export default Contact;